import {
  customInstanceWithHeader,
  type ResponseWithHeaders,
} from '@fukuri-admins/apis/client/base/axiosInstance';
import {
  getGetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsKey,
  getGetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUrl,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type {
  GetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequests200,
  GetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsParams,
} from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

const fetcher = (
  threeLetterCode: string,
  params: GetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsParams
) =>
  customInstanceWithHeader<GetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequests200>(
    getGetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsUrl(threeLetterCode, params),
    { method: 'GET' }
  );

type Args = {
  threeLetterCode: string;
  page?: string;
};

type IUseGetUserBulkCreationRequests = (args: Args) => {
  data: GetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequests200;
  totalPage: number;
  totalCount: number;
  mutate: ReturnType<typeof useFetch>['mutate'];
};

/**
 * ユーザー一括登録リクエスト一覧取得フック
 */
export const useGetUserBulkCreationRequests: IUseGetUserBulkCreationRequests = ({
  threeLetterCode,
  page,
}) => {
  const params: GetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsParams = {
    ...(page && !Number.isNaN(Number(page)) && { page: Number(page) }),
  };

  const { data, mutate } = useFetch<
    ResponseWithHeaders<GetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequests200>
  >(
    getGetApiV1ThreeLetterCodeClientAdminsUserBulkCreationRequestsKey(threeLetterCode, params),
    () => fetcher(threeLetterCode, params),
    { suspense: true }
  );

  const totalPage = Number(data.headers['total-pages']) || 0;
  const totalCount = Number(data.headers['total-count']) || 0;

  return { data: data.data, totalPage, totalCount, mutate };
};
